// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WidgetChannelFormWrapper_wrapper__1LUl7","isDrag":"WidgetChannelFormWrapper_isDrag__2neaK"};